/* eslint-disable max-len */
import React from 'react';

const UndoIcon = props => (
  <svg
    width="8px"
    height="14px"
    viewBox="0 0 8 14"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...props}
  >
    <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
      <g transform="translate(-69.000000, -18.000000)" fill="currentColor">
        <g transform="translate(48.000000, 0.000000)">
          <path d="M28.7880657,25.7733007 C28.7880657,22.8223007 26.3950657,20.4293007 23.4440657,20.4293007 C23.1920657,20.4293007 22.9420657,20.4363007 22.6950657,20.4503007 L23.9420657,19.2053007 C24.0970657,19.0503007 24.0970657,18.8003007 23.9420657,18.6453007 C23.7870657,18.4913007 23.5370657,18.4913007 23.3820657,18.6453007 L21.4230657,20.6053007 C21.2680657,20.7593007 21.2680657,21.0093007 21.4230657,21.1653007 L23.3820657,23.1243007 C23.5370657,23.2783007 23.7870657,23.2783007 23.9420657,23.1243007 C24.0970657,22.9693007 24.0970657,22.7183007 23.9420657,22.5643007 L22.6260657,21.2473007 C22.8950657,21.2293007 23.1680657,21.2213007 23.4440657,21.2213007 C25.9580657,21.2213007 27.9960657,23.2593007 27.9960657,25.7733007 C27.9960657,28.2873007 25.9590657,30.3243007 23.4460657,30.3253007 L23.1770657,30.3253007 C22.9610657,30.3253007 22.7850657,30.5013007 22.7850657,30.7173007 L22.7850657,30.7253007 C22.7850657,30.9413007 22.9610657,31.1173007 23.1770657,31.1173007 L23.5080657,31.1173007 C23.5310657,31.1173007 23.5510657,31.1083007 23.5730657,31.1043007 C26.4630657,31.0343007 28.7880657,28.6803007 28.7880657,25.7733007" />
        </g>
      </g>
    </g>
  </svg>
);

export default UndoIcon;
